module.exports = __webpack_public_path__ + "img/175e9a4.jpg";